const search = (api) => ({
  get(query) {
    return api.get('/search', { params: { query } });
  },
});

export default search;
